
// Up to 15% of the penal amount of the bond. 
// Minimum - $100, or 10% of bond, whichever is greater.

const _getMimimum = (bondvalue) => {
  const calcMinimum = (bondvalue * .1)
  let minimum = 100
  if (calcMinimum > minimum) {
    minimum = calcMinimum
  }
}

/* eslint-disable */
export const equation = ({ bondValue, premium, type, additional }) => {
  const minimum = _getMimimum(bondValue)
  let value = null
  let condition = null
  if (type === 'STATE') {
    value = (bondValue * .1)
    if (value < 50) {
      value = 50
      condition = 'Minimum not met'
    }
  }
  return { value, minimum, condition }
}
/* eslint-enable */

export default equation